import HighlyRatedFor from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/HighlyRatedFor';

export default HighlyRatedFor;
